import { useCallback, useEffect, useState } from 'react';

import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';

import { IState } from 'store';
import {
  IFilterProps,
  IShowCaseState,
  loadShowCaseData,
  updateFilters,
} from 'store/modules/showcase';

import BannersFull from 'components/common/Templates/Carousel/BannersFull';

import Checkbox from '../Checkbox';

import * as S from './styles';

interface IShowcaseAside {
  permaLink: string;
  page: number;
}

export function ShowcaseAside({ permaLink, page }: IShowcaseAside) {
  const dispatch = useDispatch();

  const {
    showcase: {
      filtros: { marcas, categorias, categoriasArvore },
    },
    banners,
  } = useSelector<IState, IShowCaseState>(state => state.showcase);
  const filters = useSelector<IState, IFilterProps>(
    state => state.showcase.filters,
  );

  const [windowWidth, setWindowWidth] = useState('web');

  function resizeWindow() {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 1200) {
        setWindowWidth('web');
      } else {
        setWindowWidth('mobile');
      }
    }
  }

  useEffect(() => {
    resizeWindow();
  }, []);

  if (typeof window !== 'undefined') {
    window.addEventListener('resize', resizeWindow);
  }

  const handleSelectCategory = useCallback(
    (ids: Array<number>, remove: boolean) => {
      const newCategories = [...filters.ca];

      ids.forEach(id => {
        if (remove) {
          const itemIndex = newCategories.findIndex(item => item === id);

          newCategories?.splice(itemIndex, 1);
        } else {
          newCategories?.push(id);
        }
      });

      dispatch(
        loadShowCaseData({
          permaLink,
          routeParams: { ...filters, ca: newCategories, pagina: page },
        }),
      );

      dispatch(
        updateFilters({
          ca: newCategories,
          pagina: page,
        }),
      );
    },
    [filters, dispatch, permaLink],
  );

  return (
    <S.Container className="showcase-aside">
      {!!categorias.length && !categoriasArvore.length && (
        <div className="filter-box without-tree">
          <h3>Categorias</h3>

          <div className="filter-box-without-tree-group">
            {categorias.map(item => (
              <Link
                key={item.id}
                href={{ pathname: `/categoria/${item.permalink}` }}
              >
                <a>
                  <p title={item.nome}>{item.nome}</p>
                </a>
              </Link>
            ))}
          </div>
        </div>
      )}

      {!!categoriasArvore.length && (
        <div className="filter-box with-tree-checkbox">
          <h3>Categorias</h3>

          <Checkbox
            type="category"
            className="father-group"
            items={categoriasArvore}
            handleSelect={handleSelectCategory}
          />
        </div>
      )}

      {!!marcas.length && (
        <div className="filter-box only-checkbox">
          <h3>Marcas</h3>

          <Checkbox
            type="brand"
            className="father-group"
            items={marcas}
            handleSelect={handleSelectCategory}
          />
        </div>
      )}

      {windowWidth === 'web' &&
        banners?.filter(banner => banner.tipo === 'VITRINE_LATERAL').length >
          0 && (
          <BannersFull
            banners={banners?.filter(
              banner => banner.tipo === 'VITRINE_LATERAL',
            )}
          />
        )}
    </S.Container>
  );
}
